module.exports = __webpack_public_path__ + "img/brainfit_1.3a4ed89e.jpg";